<template>
  <BModal
    title="Adicionar horário"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Adicionar"
    cancel-title="Sair"
    v-model="mostrar"
    @show="showModal"
    @ok="gravar"
    @cancel="cancel">
    <BForm
      @submit.prevent='gravar'
      class="modal__container">
      <InputHora
        ref="refInputHoraInicial"
        label="Horário inicial*"
        name="inputHoraInicial"
        v-model="form.horaInicial"
        class="input__horainicial"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputHora
        label="Horário final*"
        name="inputHoraFinal"
        v-model="form.horaFinal"
        class="input__horafinal"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputBasico
        type="number"
        label="Percentual (%)*"
        name="inputPercentual"
        placeholder="Ex. 50"
        v-model="form.percentual"
        class="input__percentual"
        v-validate="'required'"
        :errorsBag="errors" />

      <BFormGroup
        label="Dias da semana*"
        class="input__semana">
        <BFormCheckboxGroup
          buttons
          size="sm"
          :options="retornaDiasSemana()"
          name="inputSemana"
          v-model="form.dias"
          button-variant="primary"
          v-validate="'required'"
          :errorsBag="errors" />
      </BFormGroup>
    </BForm>
  </BModal>
</template>

<script>
import {
  BForm, BModal, BFormCheckboxGroup, BFormGroup,
} from 'bootstrap-vue/es/components'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputHora from '@/components/inputs/InputHora.vue'
import { EXISTEM_HORARIOS_MARCADOS } from '../../../mensagens/usuario.msg'
import * as dataUtils from '@/utils/data.utils'

export default {
  name: 'UsuariosHorasCadastroModal',
  props: {
    horarios: {
      required: true,
    },
  },
  components: {
    BForm,
    BModal,
    BFormCheckboxGroup,
    BFormGroup,
    InputBasico,
    InputHora,
  },
  data() {
    return {
      resolve: null,
      mostrar: false,
      form: this.valoresIniciaisForm(),
    }
  },
  methods: {
    valoresIniciaisForm() {
      return {
        horaInicial: '',
        horaFinal: '',
        percentual: '',
        dias: [],
      }
    },
    showModal() {
      this.form = this.valoresIniciaisForm()
      this.focarPrimeiroCampo()
    },
    pop() {
      this.mostrar = true
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    gravar(event) {
      event.preventDefault()
      this.$validator.validateAll(this.nomeEscopoValidacao).then(result => {
        if (result) {
          if (this.podeCadastrar()) {
            this.mostrar = false
            const retorno = this.retornaObjetoFormatado()
            this.resolve(retorno)
          } else {
            this.$awn.warning(EXISTEM_HORARIOS_MARCADOS)
          }
        }
      })
    },
    cancel() {
      this.mostrar = false
      this.resolve(false)
    },
    retornaDiasSemana() {
      return [
        { text: 'Segunda', value: { descricao: 'Segunda', diaDaSemana: 1 } },
        { text: 'Terça', value: { descricao: 'Terça', diaDaSemana: 2 } },
        { text: 'Quarta', value: { descricao: 'Quarta', diaDaSemana: 3 } },
        { text: 'Quinta', value: { descricao: 'Quinta', diaDaSemana: 4 } },
        { text: 'Sexta', value: { descricao: 'Sexta', diaDaSemana: 5 } },
        { text: 'Sábado', value: { descricao: 'Sábado', diaDaSemana: 6 } },
        { text: 'Domingo', value: { descricao: 'Domingo', diaDaSemana: 0 } },
      ]
    },
    retornaObjetoFormatado() {
      return this.form.dias.map(item => (
        {
          horaInicial: this.form.horaInicial,
          horaFinal: this.form.horaFinal,
          percentual: this.form.percentual,
          dia: item,
        }
      ))
    },
    focarPrimeiroCampo() {
      setTimeout(() => {
        this.$refs.refInputHoraInicial.focar()
      }, 1);
    },
    podeCadastrar() {
      let podeCadastrar = true
      // eslint-disable-next-line
      for (let dia of this.form.dias) {
        const diaExistente = this.horarios
          .filter(horario => horario.dia.diaDaSemana === dia.diaDaSemana)

        const horariosExistentes = diaExistente.filter(hora => {
          if (dataUtils.dataEhMaior(this.form.horaInicial, hora.horaFinal)) {
            return false
          }

          if (dataUtils.dataEhMenor(this.form.horaInicial, hora.horaInicial)
            && dataUtils.dataEhMenor(this.form.horaFinal, hora.horaInicial)) {
            return false
          }

          return true
        })

        if (horariosExistentes.length > 0) {
          podeCadastrar = false
          break
        }
      }

      return podeCadastrar
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.modal__container {
  @media (min-width: $medium-size) {
    display: grid;
    grid-column-gap: 0.8em;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
  }
}

.input {
  &__semana {
    @media (min-width: $medium-size) {
      grid-column: 1 / -1;
    }
  }

  &__horainicial {
    @media (min-width: $medium-size) {
      grid-column: 1 / 2;
    }
  }

  &__horafinal {
    @media (min-width: $medium-size) {
      grid-column: 2 / 3;
    }
  }

  &__percentual {
    @media (min-width: $medium-size) {
      grid-column: 3 / -1;
    }
  }
}

</style>
